// Languette de la messagerie de l'app (decision de Louka du 04/10) : le chat annonce a l'app la largeur
// de son panneau lateral (fichiers, apercu, fiche d'assistant) pour que la languette reste collee a la
// frontiere entre la conversation et le panneau. 0 = panneau ferme. Meme borne que l'app (4000).
export const LARGEUR_MAX_ANNONCEE = 4000;

export function largeurAnnoncee(ouvert: boolean, mesure: number): number {
  if (!ouvert || !Number.isFinite(mesure) || mesure <= 0) {
    return 0;
  }
  return Math.min(LARGEUR_MAX_ANNONCEE, Math.round(mesure));
}
